export const QUICKMATCH = {
  reviewMatch: "reviewMatch",
};

export const JOBS = {
  jobs: "jobs",
  jobSummary: "jobSummary",
  jobJobEdit: "jobJobEdit",
  jobJobEditData: "jobJobEditData",
  jobCreateEditData: "jobCreateEditData",
  jobJobRescore: "jobJobRescore",
  judicaFilter: "judicaFilter",
  jobCandidateSourcing: "jobCandidateSourcing",
  workFlowManagement: "workFlowManagement",
  jobCandidateResume: "jobCandidateResume",
};

export const RESUMEINTELLIGENCE = {
  resumeIntelligenceUpload: "resumeIntelligenceUpload",
  resumeIntelligenceSave: "resumeIntelligenceSave",
};

export const CANDIDATE = {
  candidateView: "candidateView",
  candidateBuildPipeline: "candidateBuildPipeline",
  addToJobPool: "addToJobPool",
};

export const CHATBOT = {
  chatBot: "chatBot",
  candidatechatBot: "candidatechatBot",
  comparechatBot: "comparechatBot",
};

export const COVER = {
  coverGet: "coverGet",
};

export const HARIZON = {
  harizonAnalytics: "harizonAnalytics",
};

export const CLINET_PARTNER = {
  clientAddCall: "clientAddCall",
};

export const VENDOR_PARTNER = {
  vendorAddCall: "vendorAddCall",
};

export const LAYOUT = {
  minimizeIcon: "minimizeIcon",
  pathName: "pathName",
  signUp: "signUp",
  anyChatOpen: "anyChatOpen",
  localStorage: "localStorage",
};

export const SOW = {
  sowEnrich: "sowEnrich",
  sowJudicaFilter: "sowJudicaFilter",
};

export const SUBMISSION = {
  submission: "submission",
};

export const FEEDBACK = {
  open: "open",
};

export const SNACKBAR = {
  snackBar: "snackBar",
};

export const NOTIFICATION = {
  count: "count",
};
